import { invokeApi } from "../bl_libs/invokeApi";

export const login_user_api = async (data) => {
  const requestObj = {
    path: `api/auth/login`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const change_password_api = async (data) => {
  const requestObj = {
    path: `api/auth/change-password`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const user_init_api = async () => {
  const requestObj = {
    path: `api/auth/me`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};

export const send_pin_code_api = async (data) => {
  const requestObj = {
    path: `api/auth/send-otp`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const verify_pin_code_api = async (data) => {
  const requestObj = {
    path: `api/auth/verify-otp`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const reset_password_api = async (data) => {
  const requestObj = {
    path: `api/auth/reset-password`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
